import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import AttendanceAuditsArchiveList from './AttendanceAuditsArchiveList';

const AttendanceAuditsArchive = () => {
  return renderComponent(<AttendanceAuditsArchiveList />);
};

export default AttendanceAuditsArchive;
